import InvestCircleChart from './invest-circle-chart';

export default InvestCircleChart;
